/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageDto } from '../../models/page-dto';
import { Sorting } from '../../models/sorting';
import { UserSortColumn } from '../../models/user-sort-column';

export interface GetAllUsers$Params {
  page?: number;
  'page-size'?: number;

/**
 * Filter by a search string
 */
  search?: string;

/**
 * The sort direction of the list
 */
  sort?: Sorting & any;

/**
 * The sorting of the result entries
 */
  'sort-column'?: UserSortColumn & any;
}

export function getAllUsers(http: HttpClient, rootUrl: string, params?: GetAllUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<PageDto>> {
  const rb = new RequestBuilder(rootUrl, getAllUsers.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('page-size', params['page-size'], {});
    rb.query('search', params.search, {});
    rb.query('sort', params.sort, {});
    rb.query('sort-column', params['sort-column'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageDto>;
    })
  );
}

getAllUsers.PATH = '/iam';
